import React from "react";
import { MultiCascader } from 'rsuite';
import { mockTreeData } from './mock';
import { TagPicker } from 'rsuite';
import { Image } from 'primereact/image';
import Appbar from "../../Appbar";


const data = mockTreeData({
  limits: [3],
  labels: (layer, value, faker) => {
    const methodName = ['jobArea', 'jobType', 'firstName'];
    return faker.name[methodName[layer]]();
  }
});


// const data = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
//   item => ({ label: item, value: item })
// );

const MenPro = () => {
  return (
    <div className="menPro-sec">
      <Appbar />
      <div className="def-sec">
        <h3>Men in Suit</h3>
        <div className="def-menu">
          <div className="def-list-menu">
            <div className="ind-menu">
              <img src="" alt="" />
              <span>Suits</span>
            </div>
            <div className="ind-menu">
              <img src="" alt="" />
              <span>Casual Wear</span>
            </div>
            <div className="ind-menu">
              <img src="" alt="" />
              <span>Forman Wear</span>
            </div>
            <div className="ind-menu">
              <img src="" alt="" />
              <span>Party Wear</span>
            </div>
          </div>
        </div>
      </div>
   <div style={{display:'flex'}}>
   <div className="filter-sec">
      <MultiCascader data={data} style={{ width: 224 }} />
      </div>
      <div className="tabs-sec">
      <TagPicker data={data} style={{ width: 300 }} />
      </div>
   </div>
      <div className="count-sort"></div>
      <div className="menPro-coll">
      <div className="men-dress">
          <img src="assets/Men/products/mf-1.jpg" alt="men-formal" />        
          <img src="assets/Men/products/shirt-1.jpg" alt="men-formal" />        
          <img src="assets/Men/products/jacket-1.jpg" alt="men-formal" />        
          <img src="assets/Men/products/jean-1.jpg" alt="men-formal" />        
          <img src="assets/Men/products/mj-1.jpg" alt="men-formal" />        
        </div>
        <div className="like-coll"></div>
        <div className="off-coll"></div>
        <div className="price-coll"></div>
        <div className="desc-coll"></div>
      </div>
    </div>
  );
};

export default MenPro;
